window.addEventListener('load', () => {

    document.querySelector('main').addEventListener('click', (e) => {
        if (
            e.target == document.querySelector('#block-bauer-local-tasks h2')
        ) {
            if (
                document
                    .querySelector('#block-bauer-local-tasks')
                    .classList.contains('active')
            ) {
                document
                    .querySelector('#block-bauer-local-tasks')
                    .classList.remove('active');
            } else {
                document
                    .querySelector('#block-bauer-local-tasks')
                    .classList.add('active');
            }
        }
    });

    // Mobile search style


    if (document.getElementById("block-searchapipagesearchblockform")) {
        //console.log("working")

        document.querySelector(".form-search").placeholder = "Type here...";

        const currentDiv = document.getElementById("block-searchapipagesearchblockform");

        const newCloseButton = document.createElement("div");
        newCloseButton.classList.add("mobile-search-close-button");
        newCloseButton.innerHTML = "X";

        currentDiv.appendChild(newCloseButton);

        
        var searchbutton = document.getElementById("mobile-search-button");
        searchbutton.addEventListener("click", searchShowHide);
        function searchShowHide() {
            const searchbox = document.getElementById("block-searchapipagesearchblockform");
            if (searchbox.classList.contains("active-search")) {
                searchbox.classList.remove("active-search");
            } else {
                searchbox.classList.add("active-search");
            }
        }
        
        var searchclosebutton = document.querySelector(".mobile-search-close-button");
        searchclosebutton.addEventListener("click", searchClose);
        function searchClose() {
            const searchbox = document.getElementById("block-searchapipagesearchblockform");
            if (searchbox.classList.contains("active-search")) {
                searchbox.classList.remove("active-search");
            } else {
                searchbox.classList.add("active-search");
            }
        }
        
    }
});

if (document.querySelector(".field--name-field-banner-background #media-video") !== null) {
    myVideohome = document.querySelector(".field--name-field-banner-background #media-video");
    myVideohome.muted = true; 
    myVideohome.play();
}

// Breadcrumb workaround

if (document.querySelector(".breadcrumb-box") !== null) {

    const asdf = document.querySelectorAll(".breadcrumb a");
    Array.from(asdf).forEach(function (x) {
        x.innerHTML = x.innerHTML.replace(/sng/g, "SNG &copy;")
        x.innerHTML = x.innerHTML.replace(/ngm/g, "NGM &copy;")
        x.innerHTML = x.innerHTML.replace(/mng/g, "MNG &copy;")
        x.innerHTML = x.innerHTML.replace(/nitromax/g, "NITROMAX &copy;")
    })
}

// Mobile image relocate

if (document.querySelector(".banner-image") !== null ) {
    var newParent = document.querySelector('.banner-text');
    var oldParent = document.querySelector('.banner-image');
    var getScreenWidth = window.screen.width;
    
    if (getScreenWidth < 800) {
        newParent.appendChild(oldParent);
    }
    
}

// Breadcrumb relocate

if (document.querySelector(".node--type-layout-item-breadcrumb") !== null) {
    var newBredParent = document.querySelector('.banner-content');
    var oldBredParent = document.querySelector('.node--type-layout-item-breadcrumb');

    var getScreenWidth = window.screen.width;
    
    if (getScreenWidth < 800) {
        newBredParent.appendChild(oldBredParent);
    }
}

// Read more/less button

if (document.getElementById("banner-read-more-button") !== null) {
    var bannerbutton = document.getElementById("banner-read-more-button");
    
    bannerbutton.addEventListener("click", bannerShowHide);
    function bannerShowHide() {
        const readmoretext = document.querySelectorAll(".banner-full-text");
        Array.from(readmoretext).forEach(function (x) {
            if (x.classList.contains("banner-text-hide")) {
                x.classList.remove("banner-text-hide");
                bannerbutton.firstChild.data = "Show less";
            } else {
                x.classList.add("banner-text-hide");
                document.getElementById('banner-read-more-text').scrollIntoView();
                bannerbutton.firstChild.data = "Show more";
            }
        })
    }
}

// Mobile menu

if (document.getElementById("hamburger-menu-btn") !== null) {
    var hamburgermenu = document.getElementById("hamburger-menu-btn");
    var hamburgermenuclose = document.getElementById("hamburger-menu-btn-close");
    var mobilemenu = document.getElementById("block-mainnavigation-2");
    var expandedclass = document.querySelectorAll(".menu-item--expanded");
    
    hamburgermenu.addEventListener("click", hamburgerOpen);
    hamburgermenuclose.addEventListener("click", hamburgerClose);

    function hamburgerOpen() {
        if (hamburgermenu.style.display === "none") {
          hamburgermenu.style.display = "block";
          hamburgermenuclose.style.display = "none";
          mobilemenu.style.display = "none";
        } else {
          hamburgermenu.style.display = "none";
          hamburgermenuclose.style.display = "block";
          mobilemenu.style.display = "flex";
        }
    }

    function hamburgerClose() {
        if (hamburgermenuclose.style.display === "none") {
          hamburgermenuclose.style.display = "block";
          hamburgermenu.style.display = "none";
          mobilemenu.style.display = "flex";
        } else {
          hamburgermenu.style.display = "block";
          hamburgermenuclose.style.display = "none";
          mobilemenu.style.display = "none";
        }
    }
}

const menus = document.querySelectorAll('.menu .menu-item--expanded');
menus.forEach((element) => {
    element.addEventListener('click', (event) => {

        //console.log(element);
        if (element.classList.contains('show-submenu')) {
            element.classList.remove('show-submenu');
            
        } else {
            if (
                document.querySelector('.menu .menu-item--expanded') &&
                document.querySelector('.menu .menu-item--expanded').value !== ''
            ) {
                document
                    .querySelector('.menu .menu-item--expanded')
                    .classList.remove('show-submenu');
            }
            
            element.classList.add('show-submenu');
        }
    });
});

document.onclick = function (event) {
    if (event.target.closest('.menu .menu-item--expanded')) {
    } else {
        menus.forEach((element) => {
            element.classList.remove('show-submenu');
        });
    }
};

// Append webform

function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

if (document.querySelector(".gated-button") !== null) {
    var webformDiv = document.createElement("div");
    webformDiv.setAttribute('id','gated-webform');
    var appElement = document.querySelector("main");
    appElement.appendChild(webformDiv);

    //eraseCookie('bauercookie');
    //setCookie('bauercookie','gated',1);

    //var x = getCookie('bauercookie');
    //console.log(x)
//
    //if (x !== "gated") {
    //    const buttons = document.querySelectorAll('.gated-button');
    //    for (let i = 0; i < buttons.length; i++) {
    //        buttons[i].addEventListener('click', e => e.preventDefault());
    //        buttons[i].addEventListener('click', b => {
    //            const webformShow = document.getElementById("gated-webform");
    //            webformShow.style.display = "block";
    //        });
    //    }
    //       
    //} else {
    //    console.log("Cookie already set")
    //}
}

// Radio button function

if (document.querySelector(".node--type-layout-item-radio-button") !== null) {
    //console.log("radio button");

    const firstActiveButton = document.querySelector(".layout-item-radio-button");
    firstActiveButton.classList.add("active-radio-button");
    const firstActiveText = document.querySelector(".layout-item-radio-text");
    firstActiveText.classList.add("active-radio-text");

    const radioButtons = document.querySelectorAll(".layout-item-radio-button");
    for (let i = 0; i < radioButtons.length; i++) {
        radioButtons[i].addEventListener('click', e => {
            const radioButton = document.querySelectorAll(".layout-item-radio-button");
            for (let i = 0; i < radioButton.length; i++) {
                radioButton[i].classList.remove("active-radio-button");
            }
            radioButtons[i].classList.add("active-radio-button");

            const radioText = document.querySelectorAll(".layout-item-radio-text");
            for (let i = 0; i < radioButton.length; i++) {
                radioText[i].classList.remove("active-radio-text");
            }
            radioText[i].classList.add("active-radio-text");
        });
    }
}

// Must be at the bottom

if (window.location.pathname !== "/") {
    //console.log("Not home page");

    if (document.getElementById("vidbutton") !== null) {
        const displayButton = document.getElementById("vidbutton");
        displayButton.style.display = "block";

        var ppbutton = document.getElementById("vidbutton");
        ppbutton.addEventListener("click", playPause);
        myVideo = document.getElementById("media-video");

        ppbutton.classList.remove("video-pause");
    
        function playPause() { 
            if (myVideo.paused) {
                myVideo.play();
                ppbutton.classList.remove("video-pause");
                ppbutton.classList.add("video-play");
            }
            else  {
                myVideo.pause(); 
                ppbutton.classList.add("video-pause");
                ppbutton.classList.remove("video-play");
            }
        }
    
        videoEnd = document.getElementById("media-video");
        videoEnd.onended = function(e) {
            ppbutton.classList.remove("video-play");
            ppbutton.classList.add("video-pause");
        };
    }
}

//console.log("js running")